import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FacultyType } from "../../../types/Faculty";

const initialState: FacultyType = {
    description: "",
    status: false,
    id: "",
};
export const facultySlice = createSlice({
    name: "facultyForm",
    initialState,
    reducers: {
        setUpdateFacultyData: (
            state, action: PayloadAction<FacultyType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateFacultyData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateFacultyData,resetUpdateFacultyData } = facultySlice.actions;
export default facultySlice.reducer;